/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';

import {
  dispatchFetchReminderRecipeList,
  handleErrorMessagesReminderRecipe,
  setReminderRecipeScreenTab,
} from '../../store/Actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

export default (props) => {
  // handing Onchange event & check validation on filed level
  const dispatch = useDispatch();
  const ReminderUserList = useSelector(
    (state) => state?.sharedState?.ReminderRecipientReducer?.userList
  );
  const reminderRecipeGridList = useSelector(
    (state) =>
      state?.sharedState?.ReminderRecipientReducer?.reminderRecipientList
  );
  const ReminderRecipeObj = useSelector(
    (state) => state?.sharedState?.ReminderRecipientReducer?.reminderRecipeObj
  );
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.ReminderRecipientReducer?.errorMessagesInRedux
  );
  let rowIndex = 0;
  if (reminderRecipeGridList && reminderRecipeGridList.length > 0) {
    rowIndex = reminderRecipeGridList
      ?.sort((a, b) => {
        if (a.reminderShortDescr < b.reminderShortDescr) {
          return -1;
        }
        if (a.reminderShortDescr > b.reminderShortDescr) {
          return 1;
        }
        return 0;
      })
      .findIndex((x) => {
        return x.id === props.data.id;
      });
  }
  const handleChangeSelect = (e) => {
    let localErr = [...errorMessagesFromRedux];
    const newObj = [...reminderRecipeGridList];
    newObj[rowIndex].respUserId = e.target.value;
    newObj[rowIndex].isUpdate = true;
    if (
      newObj?.filter((x) => {
        return (
          x.reminderSeqNum === newObj[rowIndex]?.reminderSeqNum &&
          x.respUserId === e.target.value &&
          x.id !== newObj[rowIndex].id
        );
      }).length > 0
    ) {
      localErr.push({
        field: `duplicateUserId${rowIndex}`,
        errorType: `duplicateUserId${rowIndex}`,
        message: `${constantMessageData.DUPLICATE_REMINDER_ERROR_MSG} # ${
          rowIndex + 1
        }.`,
      });
      newObj[rowIndex].duplicateUserIdErr = true;
    } else {
      localErr = localErr.filter(
        (item) => item.field !== `duplicateUserId${rowIndex}`
      );

      newObj[rowIndex].duplicateUserIdErr = false;
    }
    props.node.setDataValue(props?.column.colId, e.target.value);
    dispatch(
      setReminderRecipeScreenTab({
        ...ReminderRecipeObj,
        disabledSaveCancelBtn: false,
        successMessages: [],
      })
    );
    dispatch(dispatchFetchReminderRecipeList(newObj));

    dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr)]));
  };
  return (
    <div data-testid="check-log-select-box ">
      <TextField
        id={`reminderRec${rowIndex}`}
        label={`reminderRec${rowIndex}`}
        className={
          reminderRecipeGridList &&
          reminderRecipeGridList[rowIndex] &&
          reminderRecipeGridList[rowIndex].duplicateUserIdErr !== undefined &&
          reminderRecipeGridList[rowIndex].duplicateUserIdErr
            ? 'td-active-cell tBill-validate frr-display-hidden-label'
            : 'frr-display-hidden-label'
        }
        fullWidth
        select
        placeholder=""
        inputProps={{ id: `reminderRec${rowIndex}` }}
        InputLabelProps={{
          shrink: true,
        }}
        value={props?.data.respUserId || '-1'}
        onChange={(e) => {
          handleChangeSelect(e);
        }}
      >
        <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
        {ReminderUserList?.sort((a, b) => {
          if (a.userId < b.userId) {
            return -1;
          }
          if (a.userId > b.userId) {
            return 1;
          }
          return 0;
        })?.map((item) => {
          return (
            <MenuItem key={item.userId} value={item.userId}>
              {`${item.userId} | ${item.firstName} ${item.lastName}`}
            </MenuItem>
          );
        })}
      </TextField>
    </div>
  );
};
